import { createGlobalStyle } from 'styled-components';

import Gothic from '@/assets/fonts/gothic.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gothic';
    src: url(${Gothic});
  }   
  
  .generated-images-holder-var18 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var18 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .right-text-var18 {
    overflow: hidden;
    height: 100%;
    background-color: white;
    padding: 33px 43px;
    line-height: 1.2;
    width: 50%;
    text-align: center;
    color: #000;
    font-family: Gothic;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .break-var18 {
    position: absolute;
    width: 12px;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
  .half-image-var18 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
    display: block;
  }
  .actual-photo-var18 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var18--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
